// 微信相关
import to from 'await-to-js';
import * as apis from "@/api/wechat";

export default {
  namespaced: true,
  state: () => ({
    waitUnbindUserList: [],
  }),
  getters: {},
  mutations: {
    update(state, payload){
      Object.keys(payload).forEach(key => (state[key] = payload[key]));
    }
  },
  actions: {
    // 用户解绑-列表
    async getWaitUnbindUserList(ctx, payload={}) {
      const [err, res] = await to (apis.getWaitUnbindUserList(payload));
      ctx.commit("update", {
        waitUnbindUserList: !err && res.data ? res.data : undefined,
      });
    },
    // 用户解绑-允许解绑
    async allowUnbindWaitUnbindUser(ctx, payload = {}) {
      const [, res] = await to(apis.allowUnbindWaitUnbindUser(payload));
      return res;
    },
    // 用户解绑
    async unbindWaitUnbindUser(ctx, payload = {}) {
      const [, res] = await to(apis.unbindWaitUnbindUser(payload));
      return res;
    },
  },
  modules: {},
}